import { Platform } from 'react-native';
import { appTheme } from '../../shared/theme';
import { androidScaleSize } from '../../shared/theme/androidUiParity';

/** Vertical padding above the checkout footer content (excluding safe-area inset). */
export const CHECKOUT_FOOTER_VERTICAL_PAD = appTheme.spacing.sm;

/** Matches `SolidCtaClickable` `size="main"` height. */
export const CHECKOUT_FOOTER_CTA_HEIGHT = 56;

/** Total label + amount row above the CTA. */
export const CHECKOUT_FOOTER_TOTAL_ROW_HEIGHT = androidScaleSize(24);

const CHECKOUT_FOOTER_GAP = appTheme.spacing.xs;

/** Scroll content bottom inset so the last card clears the sticky footer. */
export function checkoutFooterScrollPadding(bottom_inset: number): number {
  const safe = Math.max(bottom_inset, appTheme.spacing.sm);
  return (
    CHECKOUT_FOOTER_VERTICAL_PAD +
    CHECKOUT_FOOTER_TOTAL_ROW_HEIGHT +
    CHECKOUT_FOOTER_GAP +
    CHECKOUT_FOOTER_CTA_HEIGHT +
    safe +
    (Platform.OS === 'android' ? appTheme.spacing.sm : appTheme.spacing.xs)
  );
}

/** Inner chrome radius for chips / nested surfaces inside checkout cards. */
export const CHECKOUT_CHIP_RADIUS = 12;
